import { authorisedContact } from "../../config/contact";
import "./Footer.css";
import { Link } from "react-router-dom";
import footerLogo from "../../Assets/EMEI logo.jpeg";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaArrowRight } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

// Replace platform homepages with official EMEI profile URLs when available.
const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/emei_institute?utm_source=qr&stkn=N2hhMjY0emdvODI3", Icon: FaInstagram },
  { label: "Facebook", href: "https://www.facebook.com/share/1GWStxiZzN/", Icon: FaFacebookF },
  { label: "X", href: " https://share.google/VZQPEo3IVpjSi2a2S", Icon: FaXTwitter },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/emei-professional-institute-a2520a1b4?utm_source=share_via&utm_content=profile&utm_medium=member_android", Icon: FaLinkedinIn },
  { label: "YouTube", href: "https://youtu.be/byxHYq_BKGQ?si=kFaHQ4iQgMh1Twn-", Icon: FaYoutube },
];

const linkGroups = [
  {
    title: "Explore",
    links: [
      { label: "Home", to: "/" },
      { label: "About us", to: "/about" },
      { label: "Career", to: "/career" },
      { label: "Campus gallery", to: "/gallery" },
    ],
  },
  {
    title: "Student links",
    links: [
      { label: "Student login", to: "/login" },
      { label: "Create an account", to: "/register" },
      { label: "Student dashboard", to: "/student-dashboard" },
      { label: "Career opportunities", to: "/career" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="home-footer">
      <div className="home-footer__container">
        <div className="home-footer__main">
          <div className="home-footer__content">
            <Link to="/" className="home-footer__brand" aria-label="EMEI home">
              <img src={footerLogo} alt="" className="home-footer__logo" />
              <span className="home-footer__brand-name">EMEI</span>
            </Link>
            <p className="home-footer__description">
              Discover learning opportunities, explore campus life, and take the next step in your journey.
            </p>
            <div className="home-footer__social" aria-label="Social platforms">
              {socialLinks.map(({ label, href, Icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                  aria-label={`${label} (opens in a new tab)`} title={label}>
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <nav key={group.title} className="home-footer__column" aria-label={`Footer ${group.title}`}>
              <h2>{group.title}</h2>
              <ul>
                {group.links.map((link) => (
                  <li key={link.label}><Link to={link.to}>{link.label}</Link></li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="home-footer__column">
            <h2>Connect with us</h2>
            <p>Authorised contact: <a href={authorisedContact.telephone}>{authorisedContact.phone}</a></p>
            <p>Find our location and ways to connect with the EMEI community.</p>
            <Link to="/lastpage" className="home-footer__contact-link">
              Contact &amp; location <FaArrowRight aria-hidden="true" />
            </Link>
            <Link to="/register" className="home-footer__cta">
              Join EMEI <FaArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="home-footer__bottom">
          <span>&copy; {new Date().getFullYear()} EMEI. All rights reserved.</span>
          <div className="home-footer__bottom-links">
            <Link to="/about">About EMEI</Link>
            <Link to="/lastpage">Get in touch</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
